/* @flow */
import React from 'react';

export default function ExitIcon({
  style
}: Object): React.Element {
  return <i style={style} className="material-icons">exit_to_app</i>;
}
